import React, { useContext, useEffect, useState } from "react";
import PropTypes from "prop-types";
import config from "../config";
import { DataContext } from "./DataContext";

const SearchContext = React.createContext({});

const SearchStateProvider = SearchContext.Provider;

const SearchContextProvider = ({ children }) => {
  const [searchResult, setSearchResult] = useState([] | undefined);
  const [searchTheme, setSearchTheme] = useState("FLIK-Nummer");
 const dataContext = useContext(DataContext);

  useEffect(() => {
    const feature = searchResult?.[0];
    const fid = feature?.properties?.feldblockidentnummer;

    if (!fid || feature.properties.name) {  //avoid opening the side bar when the searchResult is a Bundesland
      dataContext.setSelectedFeatures([]);
      dataContext.setSelectedFromList(undefined);
      return;
    }

    dataContext.setSelectedFeatures([feature]);
    dataContext.setSelectedFromList(feature.id)
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchResult]);


  const value = {
    searchResult,
    setSearchResult,
    searchTheme,
    setSearchTheme,
    search: {
      plz: {
        suggest: function (searchWord, callback) {
          fetch(config.backendOrigin + "api/plz/suggest/?plz=" + searchWord, {
            method: "GET",
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
            }
          })
            .then((res) => {
              if (!res.ok) {
                return false;
              }
              return res.json();
            })
            .then((data) => {
              callback(data);
            });
        },

        search: function (searchWord, callback, onError) {
          fetch(config.backendOrigin + "api/plz/?plz=" + searchWord.slice(0, 5), {
            method: "GET",
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
            }        
          })
            .then((res) => {
              if (!res.ok) {
                if (typeof onError === "function") {
                  onError(res);
                }
              } else {
                return res.json();
              }
            })
            .then((data) => {
              if (typeof callback === "function") {
                callback(data);
              }
            })
            .catch((error) => {
              console.error("Error:", error);
            });
        },
      },
      flik: {
        search: function (searchWord, callback, onError) {
          fetch(`${config.backendOrigin}api/fid/?fid=${searchWord}`, {
            method: "GET",
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
            },
            //body: JSON.stringify({ fid: searchWord }),
          })
            .then((res) => {
              if (!res.ok && typeof onError === "function") {
                onError(res);
              } else {
                return res.json();
              }
            })
            .then((data) => {
              if (typeof callback === "function" && data) {
                callback(data);
              }
            })
            .catch((error) => {
              console.error("Error:", error);
            });
        },
      },
    },
  };

  

  return <SearchStateProvider value={value}>{children}</SearchStateProvider>;
};

SearchContextProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export { SearchContext, SearchContextProvider };
